import { ExportStatus } from '@aibees/shared/components/status-tag';
import { ChipProps } from '@aibees/shared/components';
import { capitalize } from '@aibees/shared/utils';

export function humanReadableExportStatus(status: ExportStatus) {
  const refactoredStatus =
    status === ExportStatus.PENDING ? ExportStatus.PROCESSING : status;
  return (
    capitalize(refactoredStatus) +
    (refactoredStatus === ExportStatus.PROCESSING ? '...' : '')
  );
}

export const colorMap: Record<ExportStatus, ChipProps['color']> = {
  [ExportStatus.FAILED]: 'error',

  [ExportStatus.PROCESSING]: 'primary',

  [ExportStatus.PENDING]: 'warning',

  [ExportStatus.UPLOADING]: 'success',

  [ExportStatus.SUCCESS]: 'primary',

  [ExportStatus.EXPORTING]: 'warning',
};
